import { useEffect, useMemo, useState } from "react";
import { CARDS } from "../pendencias";

export function usePendenciasPorCard(pendencias) {
	const [card, setCard] = useState(null);

	const contagem = useMemo(
		() =>
			Object.fromEntries(
				CARDS.map(({ chave, tipos }) => [chave, pendencias.filter((p) => tipos.includes(p.tipo)).length])
			),
		[pendencias]
	);

	const visiveis = useMemo(() => {
		const tipos = CARDS.find(({ chave }) => chave === card)?.tipos;
		return tipos ? pendencias.filter((p) => tipos.includes(p.tipo)) : pendencias;
	}, [pendencias, card]);

	useEffect(() => {
		setCard(null);
	}, [pendencias]);

	return {
		card,
		selecionar: (chave) => setCard((atual) => (atual === chave ? null : chave)),
		contagem,
		visiveis,
	};
}
